import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { ICoworking } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Header2 } from '@cian/ui-kit/typography';

import { coworkingAmenitiesGroups } from './constants';

import { CoworkingAmenitiesGroup } from './components/CoworkinAmenitiesGroup';

const styles = require('./CoworkingAmenities.css');

interface ICoworkingAmenities extends Pick<ICoworking, 'includedAmenities'> {
  className?: string;
}

export function CoworkingAmenities({ includedAmenities, className }: ICoworkingAmenities) {
  return (
    <div id="amenities" {...mergeStyles(styles['root'], className)}>
      <Header2 as="h2">Включено в стоимость аренды</Header2>
      <div className={styles['amenities']}>
        {coworkingAmenitiesGroups.map(group => (
          <CoworkingAmenitiesGroup
            className={styles['amenities-group']}
            {...group}
            key={group.key}
            includedAmenities={includedAmenities}
          />
        ))}
      </div>
    </div>
  );
}
